export default __webpack_public_path__ + "static/Button-Smasher-App-0565f0fc714c3e6bb830ba38ce6252e1.webp";